import { useState, useEffect } from "react";
import { Checkbox } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import "./OptionsCheckboxFilter.scss";
import { BaseFilterProps } from "interfaces/filter-component-base";

export interface OptionItem {
  label: string;
  value: string;
  description?: string;
  icon?: IconDefinition;
  iconClassName?: string;
}

interface OptionsCheckboxFilterProps extends BaseFilterProps {
  options: OptionItem[];
  className?: string;
  style?: React.CSSProperties;
}

const OptionsCheckboxFilter = (props: OptionsCheckboxFilterProps) => {
  const { onChangeValues, values, options, className, style } = props;
  const [selectedValues, setSelectedValues] = useState<string[]>([]);

  useEffect(() => {
    if (values && Array.isArray(values)) {
      setSelectedValues(values);
    } else if (values && typeof values === "string") {
      setSelectedValues(values.split(";"));
    } else {
      setSelectedValues([]);
    }
  }, [values]);

  const handleOptionChange = (value: string) => {
    const newValues = selectedValues.includes(value)
      ? selectedValues.filter((v) => v !== value)
      : [...selectedValues, value];

    const uniqueValues = Array.from(new Set(newValues));
    setSelectedValues(uniqueValues);

    if (onChangeValues) {
      onChangeValues(uniqueValues.join(";"));
    }
  };

  return (
    <div className={`options-checkbox-items ${className || ""}`} style={style}>
      {options.map((option) => (
        <label key={option.value} className="options-checkbox-item">
          {option.icon && (
            <div
              className={`options-checkbox-icon ${option.iconClassName || ""}`}
            >
              <FontAwesomeIcon icon={option.icon} />
            </div>
          )}
          <div className="options-checkbox-content">
            <p className="options-checkbox-content-title">{option.label}</p>
            {option.description && (
              <p className="options-checkbox-content-description">
                {option.description}
              </p>
            )}
          </div>
          <div className="options-checkbox">
            <Checkbox
              checked={selectedValues.includes(option.value)}
              onChange={() => handleOptionChange(option.value)}
            />
          </div>
        </label>
      ))}
    </div>
  );
};

export default OptionsCheckboxFilter;
